<template>
  <div class="wrapper">
    <div class="index-selector">
      <div class="item" @click="gotoPage('/dictionary?v=1', '/pages/test/dictionary/dictionary')">
        <div>
          <img :src="tabImg.dictionary" />
        </div>
        <div>康熙字典</div>
      </div>
      <div class="item" @click="gotoPage('/nameLuck?v=1', '/pages/test/luck/luck')">
        <div>
          <img :src="tabImg.name" />
        </div>
        <div>姓名吉凶</div>
      </div>
      <div class="item" @click="gotoPage('/plum', '/pages/test/forecast/forecast')">
        <div>
          <img :src="tabImg.forecast" />
        </div>
        <div>梅花易数</div>
      </div>
    </div>
    <div class="index-selector">
      <div class="item" @click="gotoPage('/sizhu?v=1', '/pages/test/sizhu/sizhu')">
        <div>
          <img :src="tabImg.sizhu" />
        </div>
        <div>八字命理</div>
      </div>
      <div class="item" @click="goCompass">
        <div>
          <img :src="tabImg.compass" />
        </div>
        <div>风水罗盘</div>
      </div>
      <div class="item" @click="gotoPage('/consultation?v=2', '/pages/test/consultation/consultation')">
        <div>
          <img :src="tabImg.consultation" />
        </div>
        <div>预约咨询</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabImg: {
        dictionary: require('../../assets/images/icons/icon-kxcd.png'),
        name: require('../../assets/images/icons/icon-xmjx.png'),
        forecast: require('../../assets/images/icons/icon-mhyc.png'),
        sizhu: require('../../assets/images/icons/icon-bzsz.png'),
        compass: require('../../assets/images/icons/icon-fslp.png'),
        consultation: require('../../assets/images/icons/icon-zjzx.png')
      }
    }
  },
  methods: {
    gotoPage (url, miniUrl) {
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: miniUrl })
      } else {
        this.$router.push({ path: url })
      }
    },
    goCompass () {
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: '/pages/compass/compass' })
      } else {
        this.$dfzhJsBridge.openCompass()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrapper
  background-color #fff
  padding-bottom 10px
  margin-top 10px

.index-selector
  display flex
  width 100%
  margin-bottom 15px

.item
  flex-grow: 1
  font-size:12px
  font-weight:400
  color:rgba(157,157,157,1)
  line-height:16.5px

img
  width: 36px
  height: 36px
  margin: 4px 6px
</style>
